import { Link } from "react-router";
import type { Project } from "../types/project";

interface ProjectCardProps {
  project: Project;
}

export function ProjectCard({ project }: ProjectCardProps) {
  return (
    <Link
      to={`/games/${project.slug}`}
      className="project-card group relative flex min-h-60 flex-col overflow-hidden border border-zinc-800 bg-[#0b0b0b] p-5 transition-colors hover:border-zinc-300 hover:bg-zinc-100 focus-visible:border-zinc-300 focus-visible:bg-zinc-100 focus-visible:outline-none"
    >
      <div className="relative z-10 flex flex-wrap items-start justify-between gap-4 sm:flex-nowrap">
        <span className="flex flex-wrap items-center gap-3">
          <span className="whitespace-nowrap font-mono text-[10px] tracking-[0.2em] text-zinc-600 transition-colors group-hover:text-zinc-500">
            GAME // {project.index}
          </span>
          <span className="whitespace-nowrap border border-zinc-700 px-2 py-1 font-mono text-[8px] tracking-[0.14em] text-zinc-500 transition-colors group-hover:border-zinc-400 group-hover:text-zinc-700">
            {project.status}
          </span>
        </span>
        <img
          src={project.icon}
          alt={`${project.title} icon`}
          width={88}
          height={88}
          decoding="async"
          className="relative z-10 block size-16 shrink-0 border border-zinc-800 object-cover transition-colors group-hover:border-zinc-300 sm:size-[88px]"
        />
      </div>

      <div className="relative z-10 mt-auto pt-4">
        <h2 className="text-[30px] font-light uppercase leading-[1.1] tracking-[-0.03em] text-zinc-100 transition-colors group-hover:text-black">
          {project.title}
        </h2>
        <p className="mt-3 max-w-md text-sm font-light leading-6 text-zinc-500 transition-colors group-hover:text-zinc-700">
          {project.summary}
        </p>

        <div className="mt-6 flex items-center justify-between border-t border-zinc-800 pt-4 transition-colors group-hover:border-zinc-300">
          <span className="font-mono text-[9px] tracking-[0.16em] text-zinc-600">
            {project.engine} / {project.year}
          </span>
          <span
            className="font-mono text-lg text-zinc-400 transition-transform group-hover:translate-x-1 group-hover:text-black"
            aria-hidden="true"
          >
            →
          </span>
        </div>
      </div>
    </Link>
  );
}
